import { render, staticRenderFns } from "./Sectores.vue?vue&type=template&id=60a50340&scoped=true"
import script from "./Sectores.vue?vue&type=script&lang=js"
export * from "./Sectores.vue?vue&type=script&lang=js"
import style0 from "./Sectores.vue?vue&type=style&index=0&id=60a50340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a50340",
  null
  
)

export default component.exports